const bootstrap = require('bootstrap');
import { createToast } from '../bootstrap-helpers';

export const postcodeCheckerNotices = (() => {
    const checkout = document.querySelector('form[name="checkout"]');
    // Early return if not checkout form
    if (checkout == null) return;

    // Prepare observer
    let wcpnl;
    const config = { subtree: true, childList: true };
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.target.className.includes('wcnlpc-')) {
                wcpnl = mutation.target;
                const toast = createToast('Postcode fout:');
                toast._element.querySelector('.toast-body').append(wcpnl);
                wcpnl.classList.add('d-block');
                toast.show();

                checkout.addEventListener(
                    'change',
                    (e) => {
                        toast._element.remove();
                        wcpnl.remove();

                        if (e.target.getAttribute('name').includes('country')) {
                            e.target.classList.remove('woocommerce-invalid');

                            checkout.querySelectorAll('.validate-postcode').forEach((postcodeWrapper) => {
                                postcodeWrapper.classList.remove('woocommerce-invalid');

                                postcodeWrapper.querySelector('input').classList.remove('is-invalid');
                            });
                        }
                    },
                    { once: true }
                );
            }
        }
    });

    observer.observe(checkout, config);
})();
